import { ReactElement, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuthContext from 'context/useAuthContext';

// types
import { GuardProps } from 'layout/mantis/types/GuardType';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
	const { isLoggedIn } = useAuthContext();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (!isLoggedIn) {
			navigate('/login', {
				state: {
					from: location.pathname+location.search
				},
				replace: true
			});
		}
	}, [isLoggedIn, navigate, location]);

	return children;
};

export default AuthGuard;
